export const Strings_DE = {
  thwaitesglacier: 'Thwaites-Gletscher',
  antarctica: 'Antarktis',
  southpole: 'Südpol',
  southamerica: 'Südamerika',
  weddelsea: 'Weddellmeer',
  rossea: 'Rossmeer',
  belowsealevel:"Grosse Teile der westantarktischen Landmasse liegen unterhalb des Meerespiegels."
}
